module.exports = __webpack_public_path__ + "img/Flexible Character.4dda2490.svg";